// src/components/Navbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [menuActive, setMenuActive] = useState(false);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setMenuActive(false); // Close menu on link click
  };

  const toggleMenu = () => setMenuActive(!menuActive);

  return (
    <nav className="navbar">
      <a href="/">
        <img
          src={require('../../assets/logo.png')}
          alt="Logo"
          className="logo"
        />
      </a>

      <ul className={`nav-links ${menuActive ? 'active' : ''}`}>
        <li><Link to="/" onClick={handleScrollToTop}>Home</Link></li>
        <li><Link to="/about" onClick={handleScrollToTop}>About</Link></li>
        <li><Link to="/register" onClick={handleScrollToTop}>Register / Sign In</Link></li>
      </ul>

      <button className="hamburger" onClick={toggleMenu}>
        &#9776; {/* Hamburger icon */}
      </button>
    </nav>
  );
};

export default Navbar;
